import { IReflectionModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { BasePresetUtil, EMPTY_EFFECT } from './base-preset-util';
import * as ICON from '../reflection-preset-menu/preset-icons';
import _isEmpty from 'lodash/isEmpty';

const PresetIconOnShow = {
    [EMPTY_EFFECT]: ICON.DrawerEMPTY,
    'close-0-dy': ICON.DrawerClose0Dy,
    'close-4-dy': ICON.DrawerClose4Dy,
    'close-8-dy': ICON.DrawerClose8Dy,
};

const DefaultReflectionProps = {
    startOpacity: 0,
    endOpacity: 99.7,
    size: 0,
    blurRad: 0,
    dist: 0,
    sy: -1,
    dir: 90,
    rotWithShape: 0,
};

export class ReflectionPresetUtil extends BasePresetUtil {
    protected presetIcon = PresetIconOnShow;
    protected defaultEffectProps = DefaultReflectionProps;

    protected getIconName(info: IReflectionModelVal): string {
        if (_isEmpty(info)) return EMPTY_EFFECT;
        const { dist = 0, size = 0 } = info;
        if (dist === 0 && size === 0) {
            return EMPTY_EFFECT;
        }
        const sizeName = (size <= 50 ? 'close' : (size <= 60 ? 'half' : 'full'));
        const distName = dist === 0 ? 0 : (dist < 8 ? 4 : 8);
        return `${sizeName}-${distName}-dy`;
    }
}
